import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/views/login'
import Layout from '@/layout/layout'

Vue.use(Router)

/**
 * 关于 route 的配置属性说明：
 *
 * alwaysShow: true       // if set true, will always show the root menu, whatever its child routes length
 *                        // if not set alwaysShow, only more than ont route under the children
 *                        // it will becomes nested mode, otherwise not show the root menu
 *                        // 如果设置为true,它将总是出现在根目录。如果不设置的话，当它只有1个子路由的时候，会把
 *                        // 它的唯一子路由放到跟目录上来，而不显示它自己本身。
 *
 * hidden: true           // if set ture, 将不会出现在左侧菜单栏中
 */

/**
 * 基础路由： 任何角色都包含的路由
 * @type {Array}
 */
export const constantRouterMap = [
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: Login,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/',
    // hidden: true,
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/home/index'),
        meta: {icon: 'user', title: '用户管理'}
      }
    ]
  },
  {
    path: '/web',
    component: Layout,
    redirect: 'goods',
    alwaysShow: true,
    meta: {
      title: '网站管理',
      icon: 'cpu'
    },
    children: [
			{
			  path: 'pinpai',
			  name: '品牌介绍',
			  component: () => import('@/views/web/pinpai/index'),
			  meta: {title: '品牌介绍', icon: ''}
			},
			{
			  path: 'fzlc',
			  name: '发展历程',
			  component: () => import('@/views/web/fzlc/index'),
			  meta: {title: '发展历程', icon: ''}
			},
			{
			  path: 'sp',
			  name: '视频',
			  component: () => import('@/views/web/sp/index'),
			  meta: {title: '视频', icon: ''}
			},
			{
			  path: 'zjgdt',
			  name: '中间过渡图',
			  component: () => import('@/views/web/zjgdt/index'),
			  meta: {title: '中间过渡图', icon: ''}
			},
      {
        path: 'goods',
        name: '商品管理',
        component: () => import('@/views/web/goods/index'),
        meta: {title: '商品管理', icon: ''}
      },
      {
        path: 'city',
        name: '门店导航',
        component: () => import('@/views/web/city/index'),
        meta: {title: '门店导航', icon: ''}
      },
      {
        path: 'shop',
        name: '品质店铺',
        component: () => import('@/views/web/shop/index'),
        meta: {title: '品质店铺', icon: ''}
      }
    ]
  },
  {
    path: '/wx',
    component: Layout,
    redirect: 'openshop',
    alwaysShow: true,
    meta: {
      title: '小程序管理',
      icon: 'star-on'
    },
    children: [
      {
        path: 'openshop',
        name: '开店指导',
        component: () => import('@/views/app-set/openShop/index'),
        meta: {title: '开店指导', icon: ''}
      },
      {
        path: 'qa',
        name: '常见问题',
        component: () => import('@/views/app-set/qa/index'),
        meta: {title: '常见问题', icon: ''}
      },
      {
        path: 'openareas',
        name: '开放区域',
        component: () => import('@/views/app-set/openArea/index'),
        meta: {title: '开放区域', icon: ''}
      },
      {
        path: 'videos',
        name: '精彩视频',
        component: () => import('@/views/app-set/videos/index'),
        meta: {title: '精彩视频', icon: ''}
      },
      {
        path: 'dynamic',
        name: '茶乙己动态',
        component: () => import('@/views/app-set/dynamic/index'),
        meta: {title: '茶乙己动态', icon: ''}
      },
      {
        path: 'tinymce',
        name: '添加动态',
        hidden: true,
        component: () => import('@/views/app-set/dynamic/tinymce'),
        meta: {title: '添加动态', icon: ''}
      },
      {
        path: 'edit',
        name: '编辑动态',
        hidden: true,
        component: () => import('@/views/app-set/dynamic/edit'),
        meta: {title: '编辑动态', icon: ''}
      }
    ]
  },
  
  {
    path: '/application',
    component: Layout,
    meta: {
      icon: 'guide',
      title: '用户意向申请'
    },
    children: [
      {
        path: 'index',
        name: 'Profile',
        component: () => import('@/views/application'),
        meta: {icon: 'guide', title: '用户意向申请'}
      }
    ]
  },
  {
    path: '/message',
    component: Layout,
    meta: {
      icon: 'message',
      title: '消息通知'
    },
    children: [
      {
        path: 'index',
        name: 'Profile',
        component: () => import('@/views/message/index'),
        meta: {icon: 'message', title: '消息通知'}
      }
    ]
  },
  {
    path: '/userfujian',
    component: Layout,
    meta: {
      icon: 'tickets',
      title: '用户附件'
    },
    children: [
      {
        path: 'index',
        name: 'userfujian',
        component: () => import('@/views/userfujian/index'),
        meta: {icon: 's-order', title: '用户附件'}
      }
    ]
  }
]

export default new Router({
  // mode: 'history',  require service support
  // scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

/**
 * 动态路由： 根据用户角色
 * @type {Array}
 */
export const asyncRouterMap = [
]



// WEBPACK FOOTER //
// ./src/router/index.js